'use client';

import { c as _c } from "react/compiler-runtime";
import { PaymentMethodsList } from '../../../shared/composites/payment-methods';
export function CTASecurity() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col items-center gap-3"><PaymentMethodsList className="flex flex-row flex-wrap items-center justify-center gap-2" /><p className="font-base-copy text-primary">100% secure ordering due to 3-D Secure</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}